import { render, staticRenderFns } from "./MlCard.vue?vue&type=template&id=ae83894e&"
import script from "./MlCard.vue?vue&type=script&lang=js&"
export * from "./MlCard.vue?vue&type=script&lang=js&"
import style0 from "./MlCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports